const get = (key) => localStorage.getItem(key);
const set = (key, value) => localStorage.setItem(key, value);
const clear = (key) => localStorage.removeItem(key);

export default { get, set, clear };
